import React from 'react';
import { SvgSpacesMastheadTable, SvgSpacesMediumTableCertified, SvgSpacesMediumTable } from '../../../../../gen-src/icons';
import { placePageIconClass } from '../style/PlaceStyles';

export interface TableIconProps {
  readonly isCertified: boolean | null;
}

export function TableMastheadIcon(): JSX.Element {
  return <SvgSpacesMastheadTable className={placePageIconClass} />;
}

export function TableMediumIcon(props: TableIconProps): JSX.Element {
  return props.isCertified ? <SvgSpacesMediumTableCertified /> : <SvgSpacesMediumTable />;
}
